import CustomAxios from "..";

export const createNotification = async (formData) => {
  try {
    const response = await CustomAxios.post(`/push-notification/create`, formData);
    return response;
  } catch (error) {
    console.error("Error uploading notification:", error);
    throw error;
  }
};
export const updateNotification = async (id, formData) => {
  try {
    const response = await CustomAxios.put(
      `/push-notification/${id}`,
      formData
    );
    return response;
  } catch (error) {
    console.error("Error uploading notification:", error);
    throw error;
  }
};

export const getNotification = async (params = {}) => {
  try {
    const response = await CustomAxios.get("/push-notification/list", { params });
    return response;
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};

export const StatusChangeNotificationById = async (id) => {
  try {
    const response = await CustomAxios.post(
      `/push-notification/${id}/duplicate`
    );
    return response;
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};


export const TrigerNotificationById = async (id) => {
  try {
    const response = await CustomAxios.post(
      `push-notification/${id}/trigger`
    );
    return response;
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};

export const deleteNotificationById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/push-notification/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching notification:", error);
    throw error;
  }
};
